import React, { FunctionComponent, useContext } from "react";
import { hasLoginSession, getRegistrationUrl } from "../helpers/loginHelpers";
import { FormattedHTMLMessage } from "react-intl";
import { useTranslate, sendTealiumEvent } from "../helpers";
import { useFlags } from "launchdarkly-react-client-sdk";
import { LoginLogoutButton } from ".";
import { AppStore } from "../app/store";
import { UserLanguage } from "../@types";

const LoggedOutFooter: FunctionComponent = () => {
  const isLoggedIn = hasLoginSession();
  const t = useTranslate();
  const { feEnableAuthentication } = useFlags();
  const {
    state: { language },
  } = useContext(AppStore.AppContext);

  return !isLoggedIn && feEnableAuthentication ? (
    <div className="LoggedOutFooter">
      <h2 className="ds-text-heading--xl">{t("logged_out_footer.header")}</h2>
      <p className="ds-u-color--gray">
        {t("logged_out_footer.when_logged_in")}
      </p>
      <FormattedHTMLMessage id="logged_out_footer.feature_list" tagName="ul" />
      <div className="LoggedOutFooter__actions">
        <LoginLogoutButton
          className="LoggedOutFooter__login"
          onClick={(): void => {
            sendTealiumEvent("Routing", "Log in");
          }}
        />
        <span>
          {t("logged_out_footer.no_account")}{" "}
          <a
            href={getRegistrationUrl(language === UserLanguage.SPANISH)}
            className="LoggedOutFooter__createLink"
            onClick={(): void => {
              sendTealiumEvent("Routing", "Create account");
            }}
          >
            {t("logged_out_footer.create")}
          </a>
        </span>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default LoggedOutFooter;
